import { Input } from 'antd'
import React from 'react'
import { DownloadOutlined } from "@ant-design/icons";
import { fetchAttachmentURL, getInlineImage } from '../../API/api';
import { toast } from "react-toastify";
import TabSearch from '../../NewComponent/TabSearch/tabSearch';
import Button from '../../NewComponent/Button/Button';

export default function DownloadAttachment() {
  const successMsg = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
    const [text, setText] = React.useState('');
    const onChangeText = (e)=>{
      setText(e.target.value)
    }
    const downloadAttachment = (file) => {
      console.log(file)
        let payload = {
          name: file,
        };
        setText("");
        if(file.includes(".docx") || file.includes(".doc") || file.includes(".xlsx")){
          fetchAttachmentURL(payload)
          .then((res) => {
            if (res===undefined) return;
          if(!res.data.success){
            toast.error(successMsg(res.data.message));
            return;
          }
            var response = res.data.data;
                var aTag = document.createElement("a");
                aTag.setAttribute("href", response.objectUrl);
                aTag.setAttribute("download", response.name);
                aTag.click();
          })
          .catch((err) => {});
        }else if(file.includes(".mov") || file.includes(".mp4")){
          fetchAttachmentURL(payload)
          .then((res) => {
            if (res===undefined) return;
            if(!res.data.success){
              toast.error(successMsg(res.data.message));
              return;
          }
            window.open(res.data.data.objectUrl, '_blank');
          })
          .catch((err) => {});
        }
        else{
        fetchAttachmentURL(payload)
          .then((res) => {
            if (res===undefined) return;
            if(!res.data.success){
              toast.error(successMsg(res.data.message));
              return;
            }
            var response = res.data.data;
            fetch(response.src).then(function (res1) {
              res1.blob().then(function (blob) {
                var aTag = document.createElement("a");
                aTag.setAttribute("href", URL.createObjectURL(blob));
                aTag.setAttribute("download", response.name);
                aTag.click();
              });
            });
          })
          .catch((err) => {});
        }
      };
      const downloadFiles = ()=>{
        let payload = text.split(',');
        payload.filter(obj=>{
            if(obj.length !== 0){
              downloadAttachment(obj);
            }
        })
    }
  return (
    <>
        <div className='mb-2 mt-2' style={{border:'1px dashed #ACB6C6', borderRadius:'12px', background:'#fafafa', boxShadow:'lightgrey 7px 7px 20px', padding:'8px',display:'flex'}}>
         <div style={{width:'20%'}}>
            <TabSearch
            val={text}
            size={'large'}
            onChangeFunc={onChangeText}
            />
         </div>
         &nbsp;
         {text.length ===0 && <span style={{opacity:'.7', pointerEvents:'none'}}><Button text={'Download Attachment'} type={'primary'} /></span>}
         {text.length !==0 && <span ><Button text={'Download Attachment'} type={'primary'}  onClickFunc={downloadFiles} /></span>}
        </div>
    </>
  )
}
